"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmitOpeningReading = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var screen_reader_route_manager_1 = __importDefault(require("screen-reader-route-manager"));
var core_1 = require("../../../../../../shared/core");
var analytics_subjects_1 = require("../../../../analytics-subjects");
var components_1 = require("../../../../components");
var copy_1 = require("../../../../copy");
var data_1 = require("../../../../data");
var section_ids_1 = require("../../../../section-ids");
var utils_1 = require("../../../../utils");
var SubmitMeterReading_styled_1 = require("../SubmitMeterReading.styled");
var components_2 = require("../components");
var MeterHelp_1 = require("../components/MeterHelp/MeterHelp");
var SubmitOpeningReading = function (_a) {
    var _b;
    var accountId = _a.accountId, supply = _a.supply, supplyIndex = _a.supplyIndex, selectedFuel = _a.selectedFuel;
    var _c = (0, core_1.useLinks)(), meterReads = _c.meterReads, meterReadsConfirmation = _c.meterReadsConfirmation;
    var navigate = (0, ui_tools_1.useNavigate)();
    var date = 'Today';
    var _d = __read((0, react_1.useState)(false), 2), apiError = _d[0], setApiError = _d[1];
    var _e = __read((0, react_1.useState)([]), 2), errors = _e[0], setErrors = _e[1];
    var _f = (0, core_1.useComponents)(), Stack = _f.Stack, P = _f.P, ErrorSummaryNotification = _f.ErrorSummaryNotification, ErrorNotification = _f.ErrorNotification, PageLayout = _f.PageLayout, Pii = _f.Pii;
    var _g = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _g.copy, Copy = _g.Copy;
    var _h = (0, data_1.useSubmitOpeningMeterReadMutation)({
        accountId: accountId,
        sprn: supply.sprn,
        fuel: selectedFuel,
    }), submitOpeningMeterReading = _h.mutate, submitOpeningMeterReadingLoading = _h.loading;
    var errorRef = (0, react_1.createRef)();
    var onSubmit = function (data) {
        return submitOpeningMeterReading(data, {
            onCompleted: function () {
                screen_reader_route_manager_1.default.beforeRouteChange();
                var params = (0, utils_1.getSuccessRedirectParams)({
                    data: data,
                    fuel: selectedFuel,
                    supplyIndex: supplyIndex,
                    isOMR: true,
                    isPending: false,
                });
                navigate("".concat(meterReadsConfirmation(), "?").concat(params));
            },
            onError: function () {
                setApiError(true);
            },
        });
    };
    var onFormError = function (errors) {
        setApiError(false);
        setErrors(errors);
    };
    (0, react_1.useEffect)(function () {
        if (apiError && errorRef.current) {
            errorRef.current.focus();
        }
    }, [apiError, errorRef]);
    if (submitOpeningMeterReadingLoading) {
        return react_1.default.createElement(components_1.PageLoading, null);
    }
    return (react_1.default.createElement(Stack, { spaceBetween: [4, 8] },
        react_1.default.createElement(Stack, { spaceBetween: [2, 4] },
            errors.length > 0 && (react_1.default.createElement("div", null,
                react_1.default.createElement(ErrorSummaryNotification, { "data-testid": "error-summary-notification", title: copy('submitPageSummaryTitle'), id: "error-summary", errors: errors }))),
            apiError && (react_1.default.createElement(ErrorNotification, { id: "api-error", "data-testid": "api-error", ref: errorRef },
                react_1.default.createElement(ui_tools_1.AnalyticsRender, { name: analytics_subjects_1.METER_READ_POST_ERROR, properties: (_b = {}, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b[analytics_subjects_1.KAPI_ONLY] = true, _b) },
                    react_1.default.createElement(Copy, { copyKey: "apiError" })))),
            react_1.default.createElement(PageLayout, { backLink: meterReads(), id: section_ids_1.SUBMIT_OPENING_METER_READINGS_SECTION_ID, pageId: section_ids_1.SUBMIT_OPENING_METER_READINGS_SECTION_ID, "data-testid": section_ids_1.SUBMIT_OPENING_METER_READINGS_SECTION_ID, heading: react_1.default.createElement(Copy, { copyKey: "omrSubmitPageHeading", values: { fuel: selectedFuel } }) },
                react_1.default.createElement("section", { id: section_ids_1.METER_READINGS_SECTION_ID, "data-testid": section_ids_1.METER_READINGS_SECTION_ID },
                    react_1.default.createElement(Stack, { spaceBetween: 4 },
                        react_1.default.createElement(P, null,
                            react_1.default.createElement(SubmitMeterReading_styled_1.StyledLabel, null,
                                react_1.default.createElement(Copy, { copyKey: "summaryMeterSerial" })),
                            react_1.default.createElement(SubmitMeterReading_styled_1.StyledCopy, null,
                                react_1.default.createElement(Pii, null, supply.msn))),
                        react_1.default.createElement(SubmitMeterReading_styled_1.StyledDate, null,
                            react_1.default.createElement(P, null,
                                react_1.default.createElement(SubmitMeterReading_styled_1.StyledLabel, null,
                                    react_1.default.createElement(Copy, { copyKey: "readingDateLabel" })),
                                react_1.default.createElement(SubmitMeterReading_styled_1.StyledCopy, null,
                                    react_1.default.createElement(Copy, { copyKey: "submitMeterReadingTextDateToday" })))),
                        react_1.default.createElement(components_2.SubmitMeterReadingForm, { currentSupply: supply, isLoading: submitOpeningMeterReadingLoading, onSubmit: onSubmit, onError: onFormError, date: date }))))),
        react_1.default.createElement(MeterHelp_1.MeterHelpSection, { supply: supply, fuelType: selectedFuel })));
};
exports.SubmitOpeningReading = SubmitOpeningReading;
